/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import ViewModel from '@bingads-webui-component-legacy/string-list-input/viewmodel/string-list-input';
import tmpl from '@bingads-webui-component-legacy/string-list-input/template/string-list-input.pug';
import '@bingads-webui-component-legacy/extension/underscore';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/string-list-input');
var defaultSchema = {
  type: 'array',
  minItems: 0,
  maxItems: 0,
  items: {
    type: 'string',
    maxLength: 25
  }
};
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.merge({
      values: [],
      schema: defaultSchema,
      validatorMessages: {},
      id: uuid.v4(),
      placeholder: null,
      template: tmpl,
      label: null,
      lablledby: null,
      describedby: null,
      customValidators: {}
    }, options);
    this.ko_model = new ViewModel(_.defaults({
      values: this.options.values
    }, this.options));
    this.ko_model.values.subscribe((function (val) {
      this.trigger('update', val);
    }).bind(this));
    this.attrs = _.pick({
      id: this.options.id,
      'aria-label': this.options.labelledby ? null : this.options.label,
      'aria-labelledby': this.options.labelledby,
      'aria-describedby': this.options.describedby
    }, Boolean);
  },
  render: function () {
    this.$el.removeAttr('id');
    this.$el.html(this.options.template({
      i18n: i18n,
      attrs: this.attrs
    }));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  }
});
export default View;

